import React, { useContext } from "react";
import _ from "lodash";
import { Link } from "react-router-dom";
import BreakpointContext from "../../contexts/breakpointContext";
import FactoryContext from "../../contexts/factoryContext";
import styled from "styled-components";
import useIsLoading from "../../hooks/queryResults/useIsLoading";
import useLeagueSeason from "../../hooks/queryResults/useLeagueSeason";
import useWeek from "../../hooks/queryResults/useWeek";
import Util from "../../util/util";
import Loading from "../ui/Loading";

const StyledBannerContainerDiv = styled.div`
  width: 100%;

  & > a {
    text-decoration: none;
  }
`;

const StyledBannerInsideContainerDiv = styled.div`
  align-items: center;
  background-color: ${(props) => props.colors.first};
  color: ${(props) => props.colors.second};
  font-size: ${(props) => props.fontSize};
  display: flex;
  width: 100%;
`;

const StyledTeamNameDiv = styled.div`
  flex-grow: 10;
  padding: 0.25rem;
`;

export default function TeamBanner({ team, size, score, predictedScore }) {
  const factory = useContext(FactoryContext);
  const breakpoints = useContext(BreakpointContext);
  const { league, leagueSeason, leagueQuery } = useLeagueSeason();
  const { selectedWeek } = useWeek();

  const isLoading = useIsLoading(league, leagueSeason, leagueQuery);
  if (isLoading) return <Loading />;

  const linkUrl = `/${league.getIdOrSlug()}/${leagueSeason.obj.season}/${
    team.idOrSlug
  }/${Util.weekToUrl(selectedWeek)}`;

  const teamLogos = factory.makeTeamLogoCollection(team);
  const teamLogo = teamLogos.getActiveLogo();

  if (!size) size = breakpoints.message();

  let fontSize;
  let logoImg;

  if (["xl", "lg", "md"].includes(size)) {
    fontSize = "1.75rem";
    logoImg = teamLogo.getImgLg();
  } else if (size === "sm") {
    fontSize = "1.25rem";
    logoImg = teamLogo.getImgMd();
  } else {
    fontSize = "0.8rem";
    logoImg = teamLogo.getImgSm();
  }

  let scoreDiv = null;
  if (!_.isUndefined(score) || !_.isUndefined(predictedScore)) {
    let scoreToShow;
    if (_.isUndefined(score)) {
      // predicted score
      scoreToShow = (
        <span
          style={{ opacity: 0.5 }}
          title={`Predicted score based on starters scoring in last 5 games`}
        >
          {predictedScore}
        </span>
      );
    } else {
      // actual score
      scoreToShow = score.toFixed(2);
    }
    scoreDiv = (
      <div style={{ padding: "0.25rem", marginLeft: "0.5rem" }}>
        {scoreToShow}
      </div>
    );
  }

  return (
    <StyledBannerContainerDiv>
      <Link to={linkUrl}>
        <StyledBannerInsideContainerDiv
          colors={team.colors.obj}
          fontSize={fontSize}
        >
          {logoImg}
          <StyledTeamNameDiv>{team.fullName}</StyledTeamNameDiv>
          {scoreDiv}
        </StyledBannerInsideContainerDiv>
      </Link>
    </StyledBannerContainerDiv>
  );
}
